import "./CookiesPolicy.module.css";
import Header from "@/reusable_sections/Header";
import CookiesPolicy from "./sections/CookiesPolicy";
import Footer from "@/reusable_sections/Footer";
export default function CookiesPolicyPage() {
  return <div>
      <Header />
      <CookiesPolicy />
      <Footer />
    </div>;
}